import React, { ReactNode } from 'react'

import cx from 'classnames'

import { Button } from '@driftt/tide-core'

import styles from './styles.module.css'

interface FiltersFormPopperProps {
  isFilterCardShown?: boolean
  onFilterChange?: () => void
  children: ReactNode
  ref: any
  popperStyles: Record<string, any>
  attributes: Record<string, any>
  onSaveFilters: () => void
  onApplyFilters: () => void
  onCancel: () => void
}

const FiltersFormPopper: React.FC<FiltersFormPopperProps> = React.forwardRef((props, ref) => {
  const { isFilterCardShown, attributes, popperStyles, children } = props

  return (
    <div ref={ref} style={popperStyles} className={styles.popper} {...attributes.popper}>
      <div
        className={cx(styles.cardStyle, {
          [styles.isShown]: isFilterCardShown
        })}>
        {children}
        <div className={styles.footerContainer}>
          <div>
            <Button onClick={props.onApplyFilters} type="primary" className={styles.marginRight}>
              Apply
            </Button>
            <Button onClick={props.onCancel} type="tertiary">
              Cancel
            </Button>
          </div>
          <Button onClick={props.onSaveFilters} type="secondary">
            Save filters
          </Button>
        </div>
      </div>
    </div>
  )
})

export default FiltersFormPopper
